import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Link } from "expo-router";
import { useState } from "react";
import { Image, Platform, Pressable, StyleSheet, View, } from "react-native";
import { useCustomTheme } from "../hooks/useCustomTheme";
import { Button } from "./Button";
import { ThemedLoader } from "./ThemedLoader";
import { ThemedText } from "./ThemedText";
export const ThemedHeader = ({ logo, navigationItems = [], variant, currentSchool, currentSchoolLoading, onLogout, logoutLabel = "Abmelden", showNavigation = true, customAction, }) => {
    const { colors, fonts } = useCustomTheme();
    const [isHovered, setIsHovered] = useState(false);
    const [hoveredNavigationKey, setHoveredNavigationKey] = useState(null);
    const isLoginButton = customAction?.variant === "login";
    return (<View style={[styles.container, { backgroundColor: colors.background }]}>
      <View style={styles.logoContainer}>
        {logo && (<Image source={logo} style={styles.logo} resizeMode="contain"/>)}
      </View>

      {showNavigation && (<View style={styles.navigationContainer}>
          {navigationItems.map((item) => {
                const itemOpacity = item.isActive || hoveredNavigationKey === item.key ? 1 : 0;
                return (<Link key={item.key} href={item.href} asChild>
                <Pressable style={styles.navigationItem} onHoverIn={() => {
                        if (!item.isActive) {
                            setHoveredNavigationKey(item.key);
                        }
                    }} onHoverOut={() => {
                        setHoveredNavigationKey((current) => current === item.key ? null : current);
                    }}>
                  <ThemedText style={[
                        styles.navigationText,
                        {
                            color: item.isActive ? colors.border : colors.text,
                            ...fonts.regular,
                        },
                    ]}>
                    {item.label}
                  </ThemedText>
                  <View style={[
                        styles.activeIndicator,
                        Platform.OS === "web"
                            ? { transitionProperty: "opacity" }
                            : undefined,
                        Platform.OS === "web"
                            ? { transitionDuration: "180ms" }
                            : undefined,
                        Platform.OS === "web"
                            ? { transitionTimingFunction: "ease-in-out" }
                            : undefined,
                        {
                            backgroundColor: colors.border,
                            opacity: itemOpacity,
                        },
                    ]}/>
                </Pressable>
              </Link>);
            })}
        </View>)}

      {!showNavigation && <View style={styles.spacer}/>}

      <View style={[styles.rightSection, { backgroundColor: colors.background }]}>
        {variant === "authenticated" &&
            (currentSchool || currentSchoolLoading) && (<View style={styles.schoolContainer}>
              <MaterialCommunityIcons name="school-outline" size={22} color={colors.border} style={styles.schoolIcon}/>
              {currentSchool ? (<ThemedText numberOfLines={2} style={[
                    styles.schoolText,
                    { color: colors.semiMuted, ...fonts.semiBold },
                ]}>
                  {currentSchool.name}
                  {currentSchool.abbreviation &&
                    ` (${currentSchool.abbreviation})`}
                </ThemedText>) : currentSchoolLoading ? (<ThemedLoader spinnerSize={30}/>) : null}
            </View>)}

        {customAction ? (<Button buttonText={customAction.label} onPress={customAction.onPress} onHoverIn={() => setIsHovered(true)} onHoverOut={() => setIsHovered(false)} iconName={customAction.iconName || "arrow-left"} iconPosition="left" iconColor={isLoginButton && isHovered
                ? colors.successLight
                : isLoginButton
                    ? colors.text
                    : colors.background} iconSize={24} buttonStyle={[
                styles.logoutButton,
                isLoginButton
                    ? [
                        styles.loginButton,
                        {
                            borderColor: isHovered
                                ? colors.successLight
                                : colors.text,
                        },
                    ]
                    : undefined,
            ]} buttonTextStyle={[
                styles.logoutButtonText,
                fonts.bold,
                isLoginButton
                    ? [
                        styles.loginButtonText,
                        {
                            color: colors.text,
                        },
                    ]
                    : { color: colors.background },
            ]}/>) : onLogout ? (<Button buttonText={logoutLabel} onPress={onLogout} onHoverIn={() => setIsHovered(true)} onHoverOut={() => setIsHovered(false)} iconName="logout" iconPosition="left" iconColor={colors.background} iconSize={22} buttonStyle={[
                styles.logoutButton,
                {
                    backgroundColor: isHovered
                        ? colors.palette.spinach20
                        : colors.border,
                },
            ]} buttonTextStyle={[
                styles.logoutButtonText,
                fonts.bold,
                { color: colors.background },
            ]}/>) : null}
      </View>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        paddingLeft: 40,
        boxShadow: "0px 8px 16px 0px #0000001A",
        elevation: 3,
        zIndex: 1000,
        height: 84,
    },
    logoContainer: {
        marginRight: 56,
    },
    logo: {
        width: 201,
        height: 50,
    },
    navigationContainer: {
        flexDirection: "row",
        flex: 1,
        gap: 32,
        height: "100%",
    },
    navigationItem: {
        position: "relative",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
    },
    navigationText: {
        fontSize: 16,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
    },
    activeIndicator: {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        height: 3,
    },
    rightSection: {
        flexDirection: "row",
        alignItems: "center",
        gap: 24,
        height: "100%",
        paddingRight: 40,
    },
    schoolContainer: {
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 12,
        paddingVertical: 8,
        width: 180,
        justifyContent: "flex-start",
    },
    schoolIcon: {
        marginRight: 8,
    },
    schoolText: {
        fontSize: 12,
        lineHeight: 16,
        letterSpacing: 12 * 0.02, // 2%
    },
    logoutButton: {
        height: 44,
        paddingHorizontal: 16,
        borderRadius: 22,
        gap: 0,
    },
    logoutButtonText: {
        fontSize: 16,
        lineHeight: 20.8,
        paddingHorizontal: 8,
    },
    spacer: {
        flex: 1,
    },
    loginButton: {
        borderWidth: 2,
        minWidth: 0,
        gap: 0,
    },
    loginButtonText: {
        fontSize: 16,
        lineHeight: 20.8,
        paddingHorizontal: 8,
    },
});
//# sourceMappingURL=ThemedHeader.js.map